<template>
    <section class="interview-title light yellow">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-theateropleiding.jpg)">
                <p class="sub-text">Niet op de foto: Bram van Bakel</p>
            </div>

            <div class="content-wrapper">
                <div class="content light yellow">
                    <h3>Interview Guido&nbsp;Bonke, Frederiek&nbsp;Haring en Bram&nbsp;van&nbsp;Bakel</h3>
                    <h2>Nieuwe theateropleiding is het beste van twee theaterwerelden</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>

</style>

<script>
    import InterviewTheateropleiding from '@/app/pages/sub/InterviewTheateropleiding';

    export default {
        name: 'RegioInterview',
        meta: {
            title: 'RegioInterview',
            color: '#FEBE06'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewTheateropleiding );
            }
        }
    };
</script>
